// Module
var code = `<div class="modal-window-content-section">
  <div class="modal-window-content-header">
    <p class="h4">{{title}}</p>
    {{#body}}
    <p>{{.*}}</p>
    {{/body}}
  </div>

  <div class="modal-window-content-body">



  </div>
</div>
`;
// Exports
module.exports = code;